module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "analytics"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loader),
      expression: "loader"
    }],
    staticClass: "spinner"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-3x",
    staticStyle: {
      "font-size": "40px",
      "color": "#228D7A"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loader),
      expression: "loader"
    }],
    staticClass: "spinnerBackground"
  }), _vm._v(" "), _c('div', {
    staticClass: "controlPanel"
  }, [_c('div', {
    staticClass: "selectSensor"
  }, [_c('p', {
    staticClass: "annot"
  }, [_vm._v(_vm._s(_vm.$t('controlPanel.selectSensor')))]), _vm._v(" "), _c('v-select', {
    attrs: {
      "value": _vm.selectedSensor,
      "label": "label",
      "on-change": _vm.selectSensor,
      "options": _vm.sensors
    },
    on: {
      "update:value": function($event) {
        _vm.selectedSensor = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "selectDate"
  }, [_c('p', {
    staticClass: "annot"
  }, [_vm._v(_vm._s(_vm.$t('controlPanel.selectDate')))]), _vm._v(" "), _c('input', {
    staticClass: "datepicker",
    attrs: {
      "type": "text",
      "name": "daterange"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-desktop dashboard"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "statsDashboard"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4 stats"
  }, [_c('div', {
    staticClass: "headingCard"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('statsDashboard.currentValues')) + " "), _c('span', {
    staticClass: "small"
  }, [_vm._v("(" + _vm._s(_vm.$t('statsDashboard.lastUpdate')) + " " + _vm._s(_vm.dailyValues.time) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "line upper"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content tempVal"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('statsDashboard.temperature')))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.dailyValues.temp) + " °C")])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content moistVal"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('statsDashboard.moisture')))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.dailyValues.moist) + " %")])])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content pressVal"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('statsDashboard.pressure')))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.dailyValues.press) + " hPa")])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content precVal"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('statsDashboard.precipitation')))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.dailyValues.prec) + " mm")])])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content pressVal"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('statsDashboard.sirr')))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.dailyValues.sirr) + " W/m2")])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content tempVal"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('statsDashboard.battery')))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.dailyValues.battery) + " V")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4 stats"
  }, [_c('div', {
    staticClass: "headingCard"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('statsDashboard.dailyStatistics')))])]), _vm._v(" "), _c('div', {
    staticClass: "line upper dailyStatsTemp"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('statsDashboard.maxTemperature')))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.dailyStats.maxTemp) + " °C")])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('statsDashboard.minTemperature')))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.dailyStats.minTemp) + " °C")])])])]), _vm._v(" "), _c('div', {
    staticClass: "line dailyStatsMoist"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('statsDashboard.maxRH')))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.dailyStats.maxMoist) + " %")])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('statsDashboard.minRH')))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.dailyStats.minMoist) + " %")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "totalPrec"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('statsDashboard.precipitationInterval')) + ":  " + _vm._s(_vm.totalPrecipitation) + " mm")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chartArea"
  }, [_c('i', {
    staticClass: "fa fa-download",
    on: {
      "click": function($event) {
        _vm.downloadData(_vm.sensorData)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartdiv"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-771892d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Analytics.vue
// module id = 217
// module chunks = 1